import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);

        this.$scope.currentPromise = null;
        this.phones = null;
        this.setPhones();

        this.$element.on('$destroy', () => {
            this.UiHelper.closeModals();
        });
    }

    setPhones() {
        this.$scope.currentPromise = this.getEmergencyPhoneNumbers().then(resp => {
            this.phones = resp.data.phone;
        });
    }

    _showUserCodeModal() {
        this.askUserCode()
            .then(userCode => {
                if (userCode) {
                    this.tryToSetPhone(userCode)
                }
            }).catch(() => {
            this.$state.reload();
        });
    }

    _showModal(modalName) {
        this.$scope.userCode = '';
        this.showModal(modalName);
    }

    _genericResponseHandle(func) {

        this.ModalDialogService.isModalClosed = false;

        this.$scope.currentPromise = func.then(() => {
            this.ModalDialogService.isModalClosed = true;
            this.popMessage(this.updateOKText);
        }).catch(err => {
            this.ModalDialogService.isModalClosed = true;
            this.popMessage(err.data.message, 'error');
        }).finally(setTimeout(this.setPhones.bind(this), 1000));

    }

    tryToSetUser(userCode) {
        this._genericResponseHandle(this._PanelsService.changePanelEmergencyPhone(this.panelId, this.phones, userCode));
    }

    onEditAddPhone(currentPhoneIndex) {
        this.currentPhoneIndex = currentPhoneIndex;
        this._showModal('editPhoneModal');
    }

    _showUserCodeModal() {
        this.askUserCode()
            .then(userCode => {
                if (userCode) {
                    this.tryToSetUser(userCode)
                }
            }).catch(() => {
            this.$state.reload();
        });
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/emergencyPhones.component/controller.js
 **/